"use strict";
/**
 * @file 对于“常规输入控件”的公共逻辑抽象
 * @description “常规输入控件”一般长成带边框的长条形，有默认的宽高，可以感知并适应所在表单/表单项（基于 size、layout 等信息）
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInputStyle = exports.useInputColor = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var defs_1 = require("../Form/defs");
var utils_1 = require("../utils");
var ConfigProvider_1 = require("../ConfigProvider");
/** 常规输入控件颜色逻辑 */
function useInputColor(_a) {
    var focused = _a.focused, disabled = _a.disabled, validateStatus = _a.validateStatus;
    var formInfo = defs_1.useFormInfo();
    var className = ConfigProvider_1.usePrefix('input-with-color');
    return classnames_1.default(className, utils_1.concat(className, 'validate-status', validateStatus !== null && validateStatus !== void 0 ? validateStatus : formInfo.validateStatus), focused && utils_1.concat(className, 'focused'), disabled && utils_1.concat(className, 'disabled'));
}
exports.useInputColor = useInputColor;
/** 常规输入控件大小、间距等逻辑 */
function useInputSize(size) {
    var formInfo = defs_1.useFormInfo();
    var className = ConfigProvider_1.usePrefix('input-with-size');
    return classnames_1.default(utils_1.concat(className, 'size', size !== null && size !== void 0 ? size : formInfo.size), utils_1.concat(className, 'layout', formInfo.layout.type));
}
/** 常规输入控件的样式（包括大小、间距、颜色等） */
function useInputStyle(_a) {
    var size = _a.size, inputStatus = tslib_1.__rest(_a, ["size"]);
    var colorClassName = useInputColor(inputStatus);
    var sizeClassName = useInputSize(size);
    return classnames_1.default(colorClassName, sizeClassName);
}
exports.useInputStyle = useInputStyle;
//# sourceMappingURL=input.js.map